// extracted by mini-css-extract-plugin
export default {"dark":"front-doors-page-container-ui--dark--t9iO4","light":"front-doors-page-container-ui--light--FZ3G5","body":"front-doors-page-container-ui--body--0zUDy"};